import React from 'react';

const SkeletonBlock = ({ className }) => (
  <div className={`animate-pulse rounded bg-gray-200 ${className}`} />
);

const StatCard = ({ title, value, change, subtitle, icon: Icon, isHighlight, loading }) => (
  <div
    className={`p-5 rounded-lg border hover:shadow-sm transition-shadow ${isHighlight
        ? 'bg-status-hot-bg/10 border-status-hot-bg'
        : 'border-notion-border'
      }`}
  >
    <div className="flex items-center justify-between mb-4">
      <span className={`text-sm font-medium ${isHighlight ? 'text-stone-600' : 'text-notion-text-light'}`}>
        {title}
      </span>
      <Icon className={`w-4 h-4 ${isHighlight ? 'text-status-hot-text' : 'text-notion-text-light'}`} />
    </div>
    <div className="flex items-baseline gap-3">
      {loading ? (
        <SkeletonBlock className="h-7 w-24" />
      ) : (
        <>
          <span className="text-2xl font-semibold text-notion-text">{value}</span>
          {change && (
            <span className="text-xs font-medium text-status-success-text bg-status-success-bg px-1.5 py-0.5 rounded">
              {change}
            </span>
          )}
          {subtitle && (
            <span className={`text-xs ${isHighlight ? 'font-medium text-status-hot-text' : 'text-notion-text-light'}`}>
              {subtitle}
            </span>
          )}
        </>
      )}
    </div>
  </div>
);

export default StatCard;
